import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import AccommodationTextList from './AccommodationTextList'

type Props = {
  maximumRoomCapacities: Array<string>
}

function AccommodationMaximumRoomCapacities({ maximumRoomCapacities }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: '_VYJWxjzFF0zQLXVBjmV',
    defaultMessage: 'Maximum room capacity',
  })

  return (
    <>
      <BodyText variant="medium" weight="bold" as="h4">{heading}</BodyText>
      <AccommodationTextList items={maximumRoomCapacities} />
    </>
  )
}

export default AccommodationMaximumRoomCapacities
